/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Pt_KelasInputs */

const en_cp_pt_kelas = /** @type {(inputs: Cp_Pt_KelasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Class (10–39 teams)`)
};

const id_cp_pt_kelas = /** @type {(inputs: Cp_Pt_KelasInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelas (10–39 tim)`)
};

/**
* | output |
* | --- |
* | "Class (10–39 teams)" |
*
* @param {Cp_Pt_KelasInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_pt_kelas = /** @type {((inputs?: Cp_Pt_KelasInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Pt_KelasInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_pt_kelas(inputs)
	return en_cp_pt_kelas(inputs)
});